import type { TurnView } from "../store"
import { authorities, type Authority } from "./authorities"

function Entry({ a }: { a: Authority }) {
  return (
    <li>
      {a.title}
      {a.citation ? <>, {a.citation}</> : null}
      {a.url ? <> <span className="a4-auth-url">{a.url}</span></> : null}
    </li>
  )
}

/** The numbered Authorities list at the end of a printed answer. Hidden on screen; shown by the print styles only. */
export function AuthoritiesPrint({ view }: { view: TurnView }) {
  const list = authorities(view)
  if (!list.length) return null
  return (
    <section className="a4-auth" aria-hidden="true">
      <h3>Authorities</h3>
      <ol>
        {list.map((a) => <Entry key={a.id} a={a} />)}
      </ol>
    </section>
  )
}
